import React, { MutableRefObject, useMemo, useState } from 'react';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { useHistory } from 'react-router-dom';
import { hideSearchBar } from 'store/slices/searchBar';
import { closeNavMenu, closeProfileMenu, openNavMenu, openProfileMenu } from 'store/slices/menu';
import { logoutIfSampleUser, sampleUser } from 'store/slices/auth';
import { NavigableStepComponent, Step } from './NavigableStepComponent';
import { HelpTypes } from 'store/slices/help';

export const GrowNetworkTutorial: React.FC<{
    onShapeChange: (shape: 'circle' | 'square') => void,
    onClickHoleRef: MutableRefObject<() => void>
}> = ({
    onShapeChange,
    onClickHoleRef
}) => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const auth = useAppSelector((s) => s.auth);
    const isSample = auth.tokenData?.data?.isSample;
    const isLoggedIn = auth.userLoginSuccess && !!auth.jwt;
    const loginRequestVisible = Boolean(!isLoggedIn || isSample);
    const tokenData = auth.tokenData;
    const [index, setIndex] = useState(0);

    const steps = useMemo<Step[]>(
        () => [
            {
                message: 'Sign in or Sign up to create an account you can link to your social media',
                type: HelpTypes.INFORMATION,
                shape: 'circle',
                visible: loginRequestVisible,
                onShow: () => {
                    dispatch(closeProfileMenu());
                    dispatch(hideSearchBar());
                    dispatch(openNavMenu());
                },
                onHide: () => {
                    dispatch(hideSearchBar());
                    dispatch(closeNavMenu());
                },
            },
            {
                message: 'Once logged in, click on your profile',
                type: HelpTypes.INFORMATION,
                shape: 'circle',
                visible: true,
                onShow: () => {
                    if (loginRequestVisible) {
                        dispatch(sampleUser());
                    }
                    dispatch(closeProfileMenu());
                },
                onPrev: () => {
                    dispatch(logoutIfSampleUser());
                },
            },
            {
                message: 'Click \'Edit profile\'',
                type: HelpTypes.INFORMATION,
                shape: 'circle',
                visible: true,
                onShow: () => {
                    dispatch(openProfileMenu());
                },
                onHide: () => {
                    dispatch(closeProfileMenu());
                },
            },
            {
                message: 'Change your details and add a picture.',
                type: HelpTypes.INFORMATION,
                shape: 'circle',
                visible: true,
                onShow: () => {
                    history.push('/edit-profile');
                },
                onHide: () => {
                    history.push('/');
                },
            },
            {
                message: 'Also, add your related social media so people can find you there as well.',
                type: HelpTypes.INFORMATION,
                shape: 'circle',
                visible: true,
                onShow: () => {
                    history.push('/edit-profile');
                },
                onHide: () => {
                    history.push('/');
                },
            },
        ],
        [dispatch, history, tokenData, isLoggedIn, isSample]
    );

    return (
        <NavigableStepComponent
            steps={steps}
            index={index}
            setIndex={(i) => {
                console.log(`setIndex called: ${i}`);
                setIndex(i);
            }}
            onClose={() => {
                console.log('Tutorial onClose called');
                dispatch(logoutIfSampleUser());
                history.push('/');
                setIndex(0);
            }}
            onShapeChange={(shape) => {
                console.log(`onShapeChange: ${shape}`);
                onShapeChange(shape);
            }}
            onClickHoleRef={onClickHoleRef}
        />
    );
};
